import { solution } from '../../lib/words'

type Props = {
  guess: string
}

export const CompletedRow = ({ guess }: Props) => {

  return (
    <div className="flex justify-center mb-1">
      <div className="w-80 h-8 border-solid border-2 items-center justify-center flex mx-0.5 text-sm font-bold rounded border-slate-600">
        {guess != "SKIPPED" ? <div className="text-slate-600">
          {guess === solution ? `✅ ${guess}` : `❌ ${guess}`}
        </div>
          : <div className="text-slate-600">
            Skipped
          </div>}
      </div>
    </div>
  )
}
